import * as React from 'react';
const { useState, useRef, useEffect, Fragment } = React;

import Divider from '..//divider';
import Box from '../box';
import {
	Root,
	HeaderLayout,
	ContentLayout,
	FooterLayout,
} from './styled';


type HeaderRendererOptions = {
	isScrolledDown: boolean;
}

export type ActionScreenProps = {
	renderHeader?: (options: HeaderRendererOptions) => React.ReactNode;
	renderFooter?: () => React.ReactNode;
};

const ActionScreenBase: React.SFC<ActionScreenProps> = (props) => {
	const {
		renderHeader,
		renderFooter,
		...rest
	} = props;
	const [isScrolledDown, setIsScrolledDown] = useState<boolean>(false);
	const scrollRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		const handleScroll = () => {
			const scrollTop = scrollRef.current.scrollTop;
	
			if (scrollTop > 10 && !isScrolledDown) {
				setIsScrolledDown(true);
			}
	
			if (scrollTop === 0 && isScrolledDown) {
				setIsScrolledDown(false);
			}
		};

		scrollRef.current.addEventListener('scroll', handleScroll);
		return () => scrollRef.current.removeEventListener('scroll', handleScroll)
	}, [isScrolledDown]);

	return (
		<Root {...rest}>
			{typeof renderHeader === 'function' && renderHeader({ isScrolledDown })}
			<ContentLayout ref={scrollRef}>
				{props.children}
			</ContentLayout>
			{typeof renderFooter === 'function' && 
				<Box width='100%'>
					<Divider />
					{renderFooter()}
				</Box>
			}
		</Root>
	);
}

ActionScreenBase.displayName = 'ActionScreen';
ActionScreenBase.defaultProps = {};

const ActionScreen = {
	Base: ActionScreenBase,
	Header: HeaderLayout,
	Footer: FooterLayout,
};

export default ActionScreen;
